export default __webpack_public_path__ + "static/media/communityIllustration.63e40e2e.png";